import { render } from "./Materiall.vue?vue&type=template&id=8db1db36"
import script from "./Materiall.vue?vue&type=script&lang=js"
export * from "./Materiall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__